const SET_WHOLE_LIST = "TABLE/WHOLE_LIST";
const SET_TABLE_CHECKBOX = "TABLE/TABLE_CHECKBOX";

const Types = {
  SET_WHOLE_LIST,
  SET_TABLE_CHECKBOX,
};

export default Types;
